import styled from 'styled-components'

export const NewsletterCheckboxWrapper = styled.div`
  margin-right: 15px;
  z-index: 5;
`

export const PasswordRequirementsWrap = styled.div`
  position: absolute;
  margin-top: 10px;
  background: ${({ theme }) => theme.background.secondary};
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.border};
  z-index: 10;
`

export const PasswordCheckWrap = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`
